import {createClient} from '@supabase/supabase-js';

// These are public client identifiers. Authorization is enforced by Supabase RLS.
export const supabase=createClient(
  'https://iboollewdbhbkaekxpxq.supabase.co',
  'sb_publishable_s7FKauaGWIH1h40obgJ5Yg__HhAlcbB',
  {auth:{persistSession:true,autoRefreshToken:true,detectSessionInUrl:true}}
);
